// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-fluid[data-v-2659b4e6]{min-height:200px}", ""]);
// Exports
module.exports = exports;
